
import {Validatable} from "../mixins/validatable";

export default Validatable.extend({
	data() {
		return {
			isOpened: false,
			isManual: false,
			manualInput: "",
			isTouching: false
		};
	},
	props: {
		value: {
			type: [Date, Array as () => Date[], Object as () => { start: Date, end: Date }],
		},
		mode: {
			type: String,
			default: ()=> "single"
		},
		fancy: Boolean,
		isExpanded: Boolean,
		label: [String, Object],
		minDate: Date,
		maxDate: Date,
		locale: {
			type: String,
			default: ()=> "en-GB",
		},
		navVisibility: String,
		popoverVisibility: {type: String, default: "focus"},
		attributes: Array as () => any[],
		disabledAttributes: Object as () => any,
		disabled: Boolean,
		nullable: Boolean,
		hasError: Boolean,
		placeholder: [String, Object]
	},
	computed: {
		dateString(): string {
			if (this.isManual) {
				return this.manualInput;
			}

			if (!this.value) {
				return "";
			}
			if (this.value instanceof Date) {
				return this.value.toLocaleDateString("nl-be");
			}
			if (this.value.constructor === Array) {
				return (this.value as Date[]).map((d: Date) => d.toLocaleDateString("nl-be")).join(", ");
			}
			let val = this.value as { start: Date, end: Date };
			return val.start.toLocaleDateString("nl-be") + " - " + val.end.toLocaleDateString("nl-be");
		},
		theme():any {
			return {
				container: {
					light: "w-calendar-container"
				},
				title: {
					light: "white-text",
				},
				arrows: {
					light: "white-text"
				},
				weekdays: {
					light: "white-text"
				}
			};
		},
		iconLeft():string | undefined{
			if (this.nullable){
				return "calendar-alt";
			}
			return undefined;
		},
		icon():string{
			if (this.nullable){
				return "times";
			}
			return "calendar-alt";
		},
		iconClickHandler():Function | undefined {
			if (this.nullable){
				return ()=>{
					this.onInput(null);
				};
			}
			return undefined;
		},
	},
	methods: {
		onFocus() {
			this.isOpened = true;
			this.$emit("focus");
		},
		onInput(newValue: Date | null) {
			if (!newValue && !this.nullable) return;
			this.isManual = false;
			this.manualInput = "";
			this.$emit("input", newValue);
			this.isOpened = false;
			this.isTouching = false;
		},
		onBlur() {
			if (this.isManual) {
				this.parseManualInput();
			}
			this.isManual = false;
			this.isOpened = false;
			this.$emit("blur");
		},
		focus() {
			(this.$refs.input as any).focus();
		},
		blur() {
			if (this.$refs.input){
				(this.$refs.input as any).blur();
			}
			if (this.$refs.datePicker) {
				console.log(this.$refs.datePicker);
				if (Array.isArray(this.$refs.datePicker)){
					this.$refs.datePicker.forEach((d:any)=>d.$el.blur());
				}else{
					(this.$refs.datePicker as any).$el.blur();
				}
			}
		},
		parseManualInput(){
			this.manualInput = this.manualInput.trim();
			if (!/^[0-9][0-9]?[\/\-][0-1]?[0-9][\/\-][0-9]+$/.test(this.manualInput))return;
			let [dateStr, monthStr, yearStr] = this.manualInput.split(/[\/\-]/);
			let year = parseInt(yearStr);
			let month = parseInt(monthStr);
			let date = parseInt(dateStr);
			if (isNaN(year) || isNaN(month) || isNaN(date)) return;
			let result = new Date();
			result.setFullYear(year, month, date);
			this.$emit("input", result);
		},
		onKeyDown(event: KeyboardEvent) {
			if (/^[a-zA-Z]$/.test(event.key)){
				event.preventDefault();
			}
			if (/^[0-9]$/.test(event.key) && !this.isManual){
				this.isManual = true;
				event.preventDefault();
				event.stopPropagation();
				this.manualInput = event.key;
			}
			this.$emit("keydown", event);
		},
		onKeyUp(event: KeyboardEvent) {
			this.$emit("keyup", event);
		},
		onManualInput(event:Event){
			this.isManual = true;
			this.manualInput = (event.target as HTMLInputElement).value;
		},
		onModalInput(event:Date | null){
			this.onInput(event);
			this.blur();
		},
		onTouch(){
			this.isTouching = true;
		},
		closeModal(){
			this.isTouching = false;
			this.blur();
		}
	}
});
